module.exports = __webpack_public_path__ + "static/media/logo-white.425f8d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/logo-white.png
// module id = 2224
// module chunks = 228